import { ENV } from "../utils";

export class EnvironmentalRiskMatrixGriform {
  baseApi = ENV.BASE_API;

  async getEnvironmentalRiskMatrixGri(accessToken, id) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-gri/${id}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createEnvironmentalRiskMatrixGri(accessToken, data) {
    try {
      const url = `${this.baseApi}/add-environmentalriskmatrix-gri`;
      const params = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateEnvironmentalRiskMatrixGri(accessToken, id, data) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-gri/${id}`;
      const params = {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteEnvironmentalRiskMatrixGri(accessToken, id) {
    try {
      const url = `${this.baseApi}/delete-environmentalriskmatrix-gri/${id}`;
      const params = { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getEnvironmentalRiskMatricesGriBySite(accessToken, site) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-gri-site/${site}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
